import BannerCounter from '@components/BannerCounter';
import Column from '@components/Column';
import Image from '@components/Image';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useOnBannerClick from '@hooks/banner/useOnBannerClick';
import useAppCustom from '@hooks/useAppCustom';
import { pressActionEffect } from '@styles/mixin';
import {
    Fragment, useState,
} from 'react';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import useMainBanners from './hooks/useMainBanners';

function MainBanners() {
    const [index, setIndex] = useState<number>(0);
    const banners = useMainBanners();
    const onBannerClick = useOnBannerClick();
    const { useMainBanner } = useAppCustom().main;

    if (banners && banners.length !== 0 && useMainBanner) {
        return (
            <Container fullWidth>
                <Swiper slidesPerView={1}
                    onSlideChange={(swiper) => {
                        setIndex(swiper.realIndex);
                    }}
                    loop
                    autoplay={{ delay: 2500, pauseOnMouseEnter: true }}
                    css={css`width: 100%`}
                    modules={[Autoplay]} >
                    {banners?.map((banner) => {
                        const isLink = banner.bannerLinkType !== 'NONE';
                        return (
                            <SwiperSlide key={banner.id} >
                                <ImageWrapper onClick={() => onBannerClick(banner)}>
                                    <SizedImage aria-disabled={!isLink}
                                        width={400}
                                        height={400}
                                        src={banner.imageUrl} />
                                </ImageWrapper>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
                <BannerCounter totalCount={banners.length}
                    right={16}
                    bottom={19}
                    index={index}/>
            </Container>
        );
    }
    return (<Fragment/>);
}

const Container = styled(Column)`
    padding: 0 0 var(--spacing-4);
    position: relative;
`;

const ImageWrapper = styled.div`
    padding: 0 var(--spacing-4);
    border-radius: var(--radius-sm);
    overflow: hidden;
    width: 100vw;
`;

const SizedImage = styled(Image)<{
    isDisabled?: boolean;
}>`
    aspect-ratio: 1;
    height: auto;
    width: 100%;
    object-fit: cover;
    border-radius: var(--radius-sm);
    &[aria-disabled='false'] {
        ${pressActionEffect}
    }
`;

export default MainBanners;
